export const CHART_HEIGHT = 300
export const BAR_WIDTH = 8

export enum BarType {
  Buy = 'buyAggregated',
  Sale = 'saleAggregated',
}
